export interface BreadcrumbCrumb {
  label: string;
  href?: string;
}

// Path segment after the entity id (e.g. ".../datasets/<id>/dashboards"); undefined at root.
export const getSectionSegment = (pathname: string, id?: string): string | undefined =>
  id ? pathname.split(`/${id}/`)[1]?.split("/")[0] : undefined;

interface EntityBreadcrumbsOptions {
  rootHref: string;
  // What the root crumb is called. "All" reads correctly where the nav picker
  // already names the section ("Datasets" → "All"), but a section nested under
  // a picker that says something else has to name itself: under Admin, "All"
  // alone does not say all of what.
  rootLabel?: string;
  // The entity crumb (e.g. dataset title / agent / project name). Omit while
  // the entity is still loading so no crumb is shown for it.
  entityName?: string;
  // Set only when a deeper section is showing, so the entity name links back to
  // its root and stays a plain label on the root page itself.
  entityHref?: string;
  // Trailing crumb for the active sub-section, when deeper than the root.
  sectionLabel?: string;
}

export const buildEntityBreadcrumbs = ({
  rootHref,
  rootLabel = "All",
  entityName,
  entityHref,
  sectionLabel,
}: EntityBreadcrumbsOptions): BreadcrumbCrumb[] => {
  const crumbs: BreadcrumbCrumb[] = [{ label: rootLabel, href: rootHref }];
  if (entityName !== undefined) {
    crumbs.push({ label: entityName, href: entityHref });
  }
  if (sectionLabel) {
    crumbs.push({ label: sectionLabel });
  }
  return crumbs;
};
